var _defs, _style, _use, _use2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFooterFb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 72 72",
    width: 72,
    height: 72,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "New Project") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("image", {
    width: 67,
    height: 67,
    id: "img1",
    href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEMAAABDCAMAAADwFEhBAAAAAXNSR0IB2cksfwAAAH5QTFRF////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////snyM2gAAACp0Uk5TAAIIDxYdJCgqKy0JIiwhBRcmBhkUIB8BESkQGgMNEhgEJwsjFRwbDB4OCgocSAAAAZ1JREFUeJytmOuSgjAMhQNWgQgCorCKeHdd3/8Ft5V1FoEKbXJ+M9+kSUhzCqCR407EdOb5AQa+N5uKievoPtVoLsII3xUtxHw8IE5S7FeaxKMIyyzQEJSCbDlIcFbtM7QVrQYS466HEBKSux8IxddmkKC02Rbac5TDQfyFUu40ycxHEpTy3tRWuoL2K616ojBDSEgnkp3JQWrlrZwUpTECsXyvznZsRZqKtk2E61kgEL1GsxXmyaiV/59mb3MSpWj/QsS2CAl5zYKDNQLxUCOOPoHhH5+MhIBATJ5FOZEYJ1WaMwmBeJaMjMjIJONCZFzk8LJvjlqRAxURgVjBlcy4wo3M+IaQzAiB1mFKKdhNn6Y8+HRBj1MAZAQiSxwc+eCoC0d/cPQpx//C8d9yzA+OOcYyTznmOsf9AoLEEGz3Lce9D0uG/YNjD2LZxzj2Qpb91G5PzlouxmZf73gyBt8AcDf0L/cuwtBH/Wgs6s7Az2n9KYOvlHLzEf52/cnfAovPBg6/r0R/d3hqLhad94/Q5P2jlvN4e4d56LPwC0pwlp9twy0oAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("image", {
    width: 33,
    height: 69,
    id: "img2",
    href: "data:image/svg+xml;base64,PHN2ZyBpZD0iZmFjZWJvb2stbGV0dGVyLWxvZ29fMV8iIGRhdGEtbmFtZT0iZmFjZWJvb2stbGV0dGVyLWxvZ28gKDEpIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMC40OTciIGhlaWdodD0iMjIuNDk0IiB2aWV3Qm94PSIwIDAgMTAuNDk3IDIyLjQ5NCI+CiAgPHBhdGggaWQ9IkZhY2Vib29rIiBkPSJNMTE2Ljk2NSw0LjM1N3YzLjFIMTE0Ljd2My43ODdoMi4yNjlWMjIuNWg0LjY2MVYxMS4yNDJoMy4xMjhzLjI5My0xLjgxNi40MzUtMy44aC0zLjU0NVY0Ljg1MWExLjEsMS4xLDAsMCwxLDEuMDEtLjkwOGgyLjUzOVYwaC0zLjQ1M0MxMTYuODUsMCwxMTYuOTY1LDMuNzkyLDExNi45NjUsNC4zNTdaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTE0LjY5NiAtMC4wMDEpIiBmaWxsPSIjZmZmIi8+Cjwvc3ZnPgo="
  }))), _style || (_style = /*#__PURE__*/React.createElement("style", null)), _use || (_use = /*#__PURE__*/React.createElement("use", {
    id: "footer-linkdin",
    href: "#img1",
    x: 3,
    y: 3
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    id: "facebook-letter-logo (1)",
    href: "#img2",
    transform: "matrix(.42,0,0,.42,30.565,22)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterFb);
export default __webpack_public_path__ + "static/media/footer-fb.2f4a95e6a4a1421d38f78c70f0c83380.svg";
export { ForwardRef as ReactComponent };